import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query BenefitsContent($benefit: BenefitContentType!) {
    benefitsContent(benefit: $benefit) {
      uuid
      title
      description
      bannerImage
      howItWorks {
        title
        content
      }
      why {
        title
        content
      }
      faq {
        title
        content {
          q
          a
        }
        viewMoreCopy
        viewMoreUrl
      }
      smallCopy
      cta
    }
  }
`

export const benefitsContentKey = getQueryNames(query)[0]

export default query
